import EventBus from '../../services/EventBus';

export const goToMyBillingAccount = async ({ commit }) => {
  EventBus.$emit('router:push', { name: 'billing-account' });
};

export const updateServiceWorker = async ({ commit }) => {
  EventBus.$emit('sw:skipWaiting');
};
